export type AnalysisType = "databook" | "agenda" | "pdf-extract" | "contract-review" | "glossary" | "qc-check" | "trending" | "other";
export type FDDQueueItemStatus = "pending_upload" | "pending" | "in_progress" | "completed" | "error";

export type QueueItemSource = "local" | "sharepoint";

export interface FDDQueueItem {
  id: string;
  fileId: string;
  fileName: string;
  fileWebUrl: string;
  fileSize?: number;
  driveId?: string;
  source?: QueueItemSource;
  analysisType: AnalysisType;
  status: FDDQueueItemStatus;
  projectId: string;
  queuedAt: string;
  completedAt?: string;
  resultUrl?: string;
  error?: string;
}

/** One table found by the PDF Extraction /scan pass. */
export type DetectedTable = {
  id: string;
  title: string;
  tableType: "income_statement" | "balance_sheet" | "other";
  sourceFile: string;
  pageNum: number;
  pageEnd: number;
  snipImageBase64: string;
};

/** A project's last /scan result plus the user's edits to it. In memory only
 *  (see fddStore) — the snips are client data and can be megabytes. */
export type PdfExtractScan = {
  sessionId: string | null;
  tables: DetectedTable[];
  titles: Record<string, string>;
  selected: string[];
  downloaded: boolean;
  /** Date.now() at scan, to match the server's scan-session TTL. */
  scannedAt: number;
};

export interface FDDTool {
  id: AnalysisType;
  name: string;
  description: string;
  icon: string;
  /** True when the tool is listed for visibility but hasn't been built yet. */
  comingSoon?: boolean;
}

export const FDD_TOOLS: FDDTool[] = [
  { id: "databook", name: "Databook Builder", description: "Build IS/BS from trial balance", icon: "📊" },
  { id: "agenda", name: "Agenda Builder", description: "Build management agenda from databook trending questions", icon: "📝" },
  { id: "pdf-extract", name: "PDF Table Extraction", description: "Extract tables from PDF files", icon: "📄" },
  { id: "contract-review", name: "Contract Review", description: "Extract terms from contracts (PPA, LCCA, ...)", icon: "📑" },
  { id: "glossary", name: "Glossary Builder", description: "Create FDD glossary from documents", icon: "📖", comingSoon: true },
  { id: "qc-check", name: "QC Checker", description: "Run quality control checks", icon: "✅", comingSoon: true },
  { id: "trending", name: "Trending Analysis", description: "Period-over-period analysis", icon: "📈", comingSoon: true },
];
